import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'nem-main',
  template: `<ng-content></ng-content>`,
  standalone: false
})
export class NemChartMainComponent {
  @HostBinding('class') classname = 'block h-full w-full';
}
